export const EXTRACT_TEXT_API_ENDPOINT = process.env.REACT_APP_API_URL + "/v1/extract-text";

export const CHAT_API_ENDPOINT = process.env.REACT_APP_API_URL + "/v3/chat";
export const CHAT_V4_API_ENDPOINT = process.env.REACT_APP_API_URL + "/v4/chat";

export const DRIVE_UPLOAD_ENDPOINT = process.env.REACT_APP_API_URL + "/v4/drive/upload";

export const CONVERSATION_HISTORY_ENDPOINT = process.env.REACT_APP_API_URL + "/v3/history";

export const CONVERSATIONS_LIST_ENDPOINT = process.env.REACT_APP_API_URL + "/v3/conversations";
